<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <manual-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ManualCrud from "./ManualCrud";
    export default {
        name: "Manual",
        components: {ManualCrud}
    }
</script>

<style scoped>

</style>

